<template>
  <div class="flex w-full h-full items-end px justify-between py-7.5 text-center">
    <span class="copyright">{{ $t('loginClient.copyright') }}</span>

    <div class="flex justify-end gap-3 flex-grow links">
      <a :href="legalLink" target="_blank">{{ $t('loginClient.legal') }}</a>
      <a :href="cookiesPolicyLink" target="_blank">{{ $t('loginClient.cookiesPolicy') }}</a>
      <a :href="privacyPolicyLink" target="_blank">{{ $t('loginClient.privacyPolicy') }}</a>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/images/vt/icons/Logo.vue';
import documents from '@/mixins/documents';

export default {
  name: 'loginComponent',
  components: {
    Logo
  },
  data() {
    return {};
  },
  computed: {
    legalLink() {
      return `https://${documents.getDomain()}/regulation/`;
    },
    cookiesPolicyLink() {
      return `https://${documents.getDomain()}/cookie-policy/`;
    },
    privacyPolicyLink() {
      return `https://${documents.getDomain()}/files/VT_Markets_LLC_Privacy_Policy.pdf`;
    }
  }
};
</script>

<style lang="scss">
.links > a,
.copyright {
  color: #7a8699;
}

.links > a:not(:first-child) {
  @include rtl-sass-prop(border-left, border-right, 1px solid #7a8699);
  @include rtl-sass-prop(padding-left, padding-right, 12px);
}
</style>
